module.exports = __webpack_public_path__ + "static/media/haroldtenure.aac0509d.jpeg";